import { restaurant } from "../data/menu";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#1a1a1a] text-[#f6efe2] pt-20 pb-10 relative overflow-hidden"
    >
      <div className="absolute top-0 inset-x-0 h-1 flex" aria-hidden="true">
        <div className="flex-1 bg-[#2d4a22]"></div>
        <div className="flex-1 bg-white"></div>
        <div className="flex-1 bg-[#c23b22]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/pizzas/logo.webp"
              alt="Piccola Venezia logo"
              className="h-14 w-auto object-contain logo-float"
            />
            <div>
              <p className="font-serif text-2xl">{restaurant.name}</p>
              <p className="text-xs uppercase tracking-[0.18em] text-white/60">
                Pizzeria · Mamers
              </p>
            </div>
          </div>
          <p className="mt-6 text-white/75 leading-relaxed max-w-sm">
            La pâte est pétrie chaque jour dans notre cuisine par notre
            Pizzaïolo, puis préparée et cuite à la commande.
          </p>
        </div>

        <div className="space-y-3">
          <p className="text-xs uppercase tracking-[0.22em] text-[#f6c177]">
            Contact
          </p>
          <a
            href={`tel:${restaurant.phoneRaw}`}
            data-testid="footer-phone"
            className="block font-serif text-3xl sm:text-4xl text-white hover:text-[#f6c177] transition-colors"
          >
            {restaurant.phone}
          </a>
          <p className="text-white/75">
            {restaurant.address}
            <br />
            {restaurant.city}, {restaurant.country}
          </p>
          <a
            href={`https://www.facebook.com/${restaurant.facebook}`}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-facebook"
            className="inline-flex items-center gap-2 text-white/85 hover:text-[#f6c177] transition-colors mt-2"
          >
            <i className="fa-brands fa-facebook" /> @{restaurant.facebook}
          </a>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.22em] text-[#f6c177]">
            Horaires
          </p>
          <ul className="mt-4 space-y-2 text-white/85 text-sm">
            {restaurant.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-6">
                <span>{h.day}</span>
                <span
                  className={
                    h.value === "Fermé" ? "italic text-white/55" : "text-white"
                  }
                >
                  {h.value}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 border-t border-white/10 pt-6 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/55">
        <p>
          © {new Date().getFullYear()} {restaurant.name}. Tous droits réservés.
        </p>
        <p className="italic">Photos non contractuelles.</p>
      </div>
    </footer>
  );
}
